import { Component } from '@angular/core';

interface DonorsService {
  titleKey: string;
  bodyKey: string;
  icon: string;
}

interface Partner {
  name: string;
  logo: string;
}

const IMAGES = 'assets/images/donors-services';

@Component({
  selector: 'app-donors-services',
  templateUrl: './donors-services.component.html',
  styleUrls: ['./donors-services.component.css'],
})
export class DonorsServicesComponent {
  readonly services: DonorsService[] = [
    {
      titleKey: 'DONORS-SERVICES_SERVICE-PERSONALIZED-TITLE',
      bodyKey: 'DONORS-SERVICES_SERVICE-PERSONALIZED-BODY',
      icon: `${IMAGES}/personalized-donation-recommendations.svg`,
    },
    {
      titleKey: 'DONORS-SERVICES_SERVICE-CAPACITY-TITLE',
      bodyKey: 'DONORS-SERVICES_SERVICE-CAPACITY-BODY',
      icon: `${IMAGES}/capacity-building.svg`,
    },
    {
      titleKey: 'DONORS-SERVICES_SERVICE-REPORTING-TITLE',
      bodyKey: 'DONORS-SERVICES_SERVICE-REPORTING-BODY',
      icon: `${IMAGES}/grant-esg-reporting.svg`,
    },
    {
      titleKey: 'DONORS-SERVICES_SERVICE-WHITELABELED-TITLE',
      bodyKey: 'DONORS-SERVICES_SERVICE-WHITELABELED-BODY',
      icon: `${IMAGES}/whitelabeled-ngo-listings.svg`,
    },
  ];

  readonly partners: Partner[] = [
    {
      name: 'monday.com',
      logo: `${IMAGES}/partners/monday.svg`,
    },
    {
      name: 'T-Mobile',
      logo: `${IMAGES}/partners/t-mobile.png`,
    },
    {
      name: 'American Airlines',
      logo: `${IMAGES}/partners/american-airlines.png`,
    },
    {
      name: 'Halborn',
      logo: `${IMAGES}/partners/halborn.svg`,
    },
    {
      name: 'BNY',
      logo: `${IMAGES}/partners/bny.png`,
    },
  ];

  trackByServiceTitle(_index: number, service: DonorsService): string {
    return service.titleKey;
  }

  trackByPartnerName(_index: number, partner: Partner): string {
    return partner.name;
  }
}
